export interface DomUtilElementCreationOptions {
    id?: string;
    className?: string;
    style?: Partial<CSSStyleDeclaration>;
    text?: string;
    html?: string;
    container?: HTMLElement | string;
    prepend?: boolean;
}

class DomUtil {

    public query<K extends keyof HTMLElementTagNameMap>(selectors: K, scope?: Element | Document): HTMLElementTagNameMap[K] | null;
    public query<K extends keyof SVGElementTagNameMap>(selectors: K, scope?: Element | Document): SVGElementTagNameMap[K] | null;
    public query<E extends Element = Element>(selectors: string, scope?: Element | Document): E | null;
    public query(selectors: string, scope: Element | Document = document) {
        return scope.querySelector(selectors);
    }

    public queryAll<K extends keyof HTMLElementTagNameMap>(selectors: K, scope?: Element | Document): (HTMLElementTagNameMap[K])[];
    public queryAll<K extends keyof SVGElementTagNameMap>(selectors: K, scope?: Element | Document): (SVGElementTagNameMap[K])[];
    public queryAll<E extends Element = Element>(selectors: string, scope?: Element | Document): E[];
    public queryAll(selectors: string, scope: Element | Document = document) {
        return Array.from(scope.querySelectorAll(selectors));
    }

    public create<K extends keyof HTMLElementTagNameMap>(tagName: K, options?: DomUtilElementCreationOptions, create?: ElementCreationOptions): HTMLElementTagNameMap[K];
    public create(type: string, options: DomUtilElementCreationOptions = null, create: ElementCreationOptions = null): HTMLElement {
        var e = document.createElement(type, create);

        if (options) {
            if (options.style) {
                this.style(e, options.style);
            }
            if (options.text) {
                e.textContent = options.text;
            }
            if (options.html) {
                e.innerHTML = options.html;
            }
            if (options.className) {
                e.className = options.className;
            }
            if (options.id) {
                e.id = options.id;
            }
            if (options.container) {
                var parent: ParentNode = null;
                if (typeof options.container === "string") {
                    parent = this.query(options.container);
                } else {
                    parent = options.container;
                }
                if (parent) {
                    if (options.prepend) {
                        parent.prepend(e)
                    } else {
                        parent.appendChild(e)
                    }
                }
            }
        }

        return e;
    }

    public style(element: HTMLElement, style: Partial<CSSStyleDeclaration>): void {
        for (var prop in style) {
            element.style[prop] = style[prop];
        }
    }
}

export const dom = new DomUtil();

// dom.query("input")?.value;
// dom.create("input").value
// dom.create("div", {
//     id: "hello",
//     className: "hello world",
//     style: {
//         backgroundColor: "#F0F",
//         top: "0",
//         left: "0",
//         position: "fixed",
//         zIndex: "999999",
//         padding: "20px"
//     },
//     text: "HELLO WORLD",
//     container: document.body
// });